/**
 * 统一管理接口
 */
import { get, post } from './http'

/**
 * 登录请求
 * params 是请求接口携带的参数
 */
export const apiLogin = params => get('system/expert/login', params)

/**
 * 获取当前用户所有医院
 */
export const apiGetOwnHospital = params => get('service-hospital/hospital/getOwnHospitalAsExpert', params)

/**
 * 设置当前医院
 */
export const apiSetCurrentHos = params => post('service-hospital/hospital/setCurrentHospital', params)

/**
 * 获取用户信息
 */
export const getUserInfo = params => get('system/storkUser/getStorkUserInfo', params)

/**
 * 请求当前专家信息
 */
export const getExpertInfo = params => get('service-user/expert/getExpertInfo', params)

/**
 * 修改用户签名
 */
export const modSign = params => post('service-user/expert/modSign', params)

/**
 * 获取当前医院成员
 */
export const getCurHospitalMember = params => get('service-hospital/hospital/getCurHospitalMember', params)

/**
 * 删除医院成员
 */
export const delHospitalMember = params => post('service-hospital/hospital/delHospitalMember', params)

/**
 * 改变医生身份类型
 */
export const changeMemberType = params => post('service-hospital/hospital/changeMemberType', params)

/**
 * 添加医院成员
 */
export const addMember = params => post('service-hospital/hospital/addMember', params)

/**
 * 获取科室列表
 */
export const getDepartmentList = () => get('system/departmentLogo/getAllDepartmentLogo')

/**
 * 请求部位列表
 */
export const getPresetList = () => get('system/order/getAllPreset')

/**
 * 接单
 */
export const getOrder = params => post('system/order/acceptOrderByExpert', params)

/**
 * 支付订单
 */
export const payOrder = params => get('system/order/payOrder', params)

/**
 * 订单退款
 */
export const refundOrder = params => get('service-order/weChatPay/refundOrder', params)

/**
 * 质控订单
 */
export const controllerOrder = params => post('service-order/order/controllOrder', params)

/**
 * 改变订单开药状态
 */
export const changePrescribe = params => get('system/order/changeIsQc', params)

/**
 * 获取订单列表
 */
export const getOrderList = params => get('system/order/findOrderOfAccept', params)

/**
 * 查询某个订单详情
 */
export const getOrderDetail = params => get('system/order/findOrderByOrderSn', params)

/**
 * 获取图片斑块等级
 */
export const getImgPlaqueLevel = params => get('service-order/img/getImgPlaqueLevel', params)

/**
 * 改变图片斑块等级
 */
export const changeImgPlaqueLevel = params => post('service-order/img/changeImgPlaqueLevel', params)

/**
 * 改变图片诊断结论
 */
export const changeImgDescription = params => post('service-order/img/changeImgDescription', params)

/**
 * 上传报告
 */
export const uploadReport = params => post('system/order/uploadReport', params)

/**
 * 报告转审
 */
export const transOrder = params => post('system/order/transOrder', params)

/**
 * 获取报告信息
 */
export const getReportDetail = params => get('system/order/getReportByOrderSn', params)
/**
 * 上传pdf报告
 */
export const uploadPdf = params => post('service-order/report/uploadReport', params)
/**
 * 下载pdf报告
 */
export const downloadPdf = params => get('service-order/report/downloadReport', params)



// WEBPACK FOOTER //
// ./src/request/api.js